import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import {ImageService} from "../../services/image/image.service";

@Injectable({
  providedIn: 'root',
})
export class ImageResolver implements Resolve<any> {
  constructor(private imageService: ImageService) {}

  resolve(): Observable<any> {
    return this.imageService.getRandomImageWithTags();
  }
}
